// extracted by mini-css-extract-plugin
export default {"btn":"BookHoldRow_btn__LX9Sl","table-number-cell":"BookHoldRow_table-number-cell__5ZMyq","flagged":"BookHoldRow_flagged__wEgvb","tr":"BookHoldRow_tr__-Yrp0"};